import { AttachLicidPage } from './../attach-licid/attach-licid';
import { NavController } from 'ionic-angular';
import { Component } from '@angular/core';

import { AuthData } from './../../providers/auth-data';

import { InfoLicidPage } from '../info-licid/info-licid';
import { InfoCloudPage } from '../info-cloud/info-cloud';
import { OthersPage } from '../others/others';


@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {

  tab1Root = AttachLicidPage;  
  tab2Root = InfoLicidPage;  
  tab3Root = InfoCloudPage;
  tab4Root = OthersPage;


  constructor(public navCtrl: NavController, public authData: AuthData) {

  }

}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts